

class MenuDetailCell extends UITableViewCell
{
    private imageView:MUIImageView = null;
    private nameLabel:MUILabel = null;
    private formatDropdown:MUIButton = null;
    private priceTextField:MUITextField = null;
    private autoInsertSwitch:MUISwitchButton = null;

    awakeFromHTML()
    {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.formatDropdown = MUIOutlet(this, "format-dd", "MUIButton");
        this.priceTextField = MUIOutlet(this, "price-tf", "MUITextField");
        this.autoInsertSwitch = MUIOutlet(this, "auto-insert-sw", "MUISwitchButton");

        this.separatorStyle = UITableViewCellSeparatorStyle.None;
    }

    set item(i:ProductMenu)
    {
        this.nameLabel.text = i.product.name;
        this.formatDropdown.title =i.productFormat?.format?.name;
        this.priceTextField.text = i.modifyMenuPrice;
        this.autoInsertSwitch.on = i.automaticInsertion;
    }

}